module.exports = __webpack_public_path__ + "img/lupa_action.763de09f.svg";